import React, { useState } from "react";
import "./refundprojects.scss";
import DataTable from "../../../components/landing/Refundprojects/DataTable/DataTable";
import AddProject from "./AddProject";
import Loader from "../../../hooks/loader";
import { GetDataProvider } from "../../../contexts/GetDataContext";
import { useRefundProjects } from "../../../hooks/Refund/useRefundProjects";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";
const Refundprojects = () => {
  const { data, loader, handleToggle, getData } = useRefundProjects();
  const [checkAdmin, isAdmin] = useAdminAllowed();
  return (
    <>
      {loader ? <Loader /> : <></>}
      <GetDataProvider getData={getData}>
        <section className="refundprojects">
          <div className="custom-container">
            <div className="topheadings">
              <div className="leftheadings">
                <p className="toppara">CREDITS REFUND</p>
                <h4 className="dashboardhead">Refund Projects</h4> 
              </div>
              {isAdmin &&  <AddProject data={data} />}
            </div>

            <DataTable data={data} handleToggle={handleToggle} isAdmin={isAdmin}/>
          </div>
        </section>
      </GetDataProvider>

    </>
  );
};

export default Refundprojects;
